export default __webpack_public_path__ + "static/media/stephen-dawson-qwtCeJ5cLYs-unsplash.291e1246.jpg";